import React, { useEffect, useRef, useState } from 'react';
import { Grow, Menu, MenuItem, TextField, Tooltip } from '@mui/material';
import styled from 'styled-components';
import ClearIcon from '@mui/icons-material/Clear';
import { FastField, getIn, useFormikContext } from "formik";

const order_events = ["order_placed", "ordered_product", "order_refunded", "order_cancelled"]
const cart_events = ["added_to_cart", "abandoned_cart"]
const checkout_events = ["checkout_started"]
const product_events = ["product_viewed"]

const MyMenuComponent = (props: any) => {
    const { errors, touched, setFieldValue, values, handleChange } = useFormikContext<any>();
    const fieldRef: any = useRef<any>(null);
    const [anchorEl, setAnchorEl] = useState(null);
    const [nestedAnchorEl, setNestedAnchorEl] = useState<any>(null);
    const [hoveredOptionId, setHoveredOptionId] = useState<number | null>(null);
    const [selectedKey, setSelectedKey] = useState<string | null>(null);  // Save the 'name' or 'parent.child' keys
    const [selectedResolveKey, setSelectedResolveKey] = useState<string | null>(null);  // Save the 'name' or 'parent.child' keys
    let [selectedLabel, setSelectedLabel] = useState<string>('');  // Save the label for display
    const [options, setOptions] = useState<any[]>([]);
    const [searchQuery, setSearchQuery] = useState<string>(''); // State for search input
    useEffect(() => {
        if (props.menus) setOptions(props.menus);
    }, [props.menus]);
    useEffect(() => {
            const defaultKey = props.defaultValue;
            findAndSetLabelsFromKey(defaultKey);  // Set label based on defaultValue on component load
    }, [props.defaultValue, options]);
        
    // Helper function to find labels from key and set it as selectedLabel
    const findAndSetLabelsFromKey = (key: string) => {
        let label = '';
        options.find(option => {
            if (option.name === key) {
                label = option.label;  // Match parent option
                return 
            } else if (option.childs) {
                const childOption = option.childs.find((child: any) => {
                    let _key = key
                    if(key) {
                        let temp = key?.split(".");
                        if (temp && temp.length > 1 && temp.includes("products")) {
                            if (temp.includes("[0]")) {
                                // Remove the "[0]" inserted earlier
                                temp.splice(temp.indexOf("[0]"), 1);
                            }
                            temp.splice(0, 1);
                            
                            _key = temp.join(".");
                            _key = `${option.name}.${_key}`
                        } else {
                            _key = key;
                        }
                        if(key === _key){
                            return `${option.name}.${child.name}` === _key
                        }
                    } else {
                        return false
                    }
 
                });
                if (childOption) {
                    label = `${option.label} - ${childOption.label}`;  // Match child option
                    return
                }
            }
        });
        setSelectedLabel(label);
    };
    // Handle opening of the main menu
    const handleClick = (event: any) => {
        setAnchorEl(event.currentTarget);
    };
    // Handle closing of the main menu
    const handleClose = () => {
        setAnchorEl(null);
        setNestedAnchorEl(null);
        setHoveredOptionId(null);
    };
    // Handle opening of the nested menu
    const handleNestedMenuOpen = (event: any, optionId: number) => {
        event.preventDefault();
        setNestedAnchorEl(event.currentTarget);
        setHoveredOptionId(optionId);
    };
    // Handle closing of the nested menu
    const handleNestedMenuClose = (e: any) => {
        e.preventDefault();
        setSearchQuery('');
        setNestedAnchorEl(null);
        setHoveredOptionId(null);
    };
    // Handle selection of a menu item (parent or child)
    const handleMenuItemClick = (option: any, parentOption?: any) => {
        let selectionKey = '';
        let selectedResolveKey = '';
        let displayLabel = '';
        // If child option is selected, save both parent and child name keys
        if (parentOption) {
            if (order_events.includes(parentOption.name)) {
                // selectedResolveKey = `order:${parentOption.name}.${option.name}`;
                selectedResolveKey = `order:${option.name}`;
            }
            else if (checkout_events.includes(parentOption.name)) {
                selectedResolveKey = `checkout:${option.name}`;
                // selectionKey = `checkout:${parentOption.name}.${option.name}`;
            }
            else if (cart_events.includes(parentOption.name)) {
                let temp: any[] = option.name?.split(".")
                if(temp && temp.length > 1 && temp.includes("products")) {
                    let str = `${temp[0]}.[0]`
                    temp[0] = str
                    str = temp.join(".")
                    selectedResolveKey = `contact:ecom_cart_items.${str}`;
                }
                else {
                    selectedResolveKey = `contact:ecom_cart_items.${option.name}`;
                }
                // selectionKey = `contact:ecom_cart_items.${parentOption.name}.${option.name}`;
            }
            else if (product_events.includes(parentOption.name)) {
                selectedResolveKey = `contact:ecom_viewed_products.${option.name}`;
                // selectionKey = `contact:ecom_viewed_products.${parentOption.name}.${option.name}`;
            }
            selectionKey = `${parentOption.name}.${option.name}`
            displayLabel = `${parentOption.label} - ${option.label}`;
        } else {
            // If parent option (without child) is selected, save its name key directly
            selectionKey = option.name;
            displayLabel = option.label;
            selectedResolveKey = option.name;
        }
        setSelectedKey(selectionKey);  // Save key (for further use)
        setSelectedResolveKey(selectedResolveKey);  // Save key (for further use)
        setSelectedLabel(displayLabel);  // Save label for display
        handleClose();  // Close the menu
        // console.log(selectionKey, "selectionKey");
        props.onChangeCallbackFn(selectionKey, selectedResolveKey);
    };
    // Handle search query change
    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchQuery(e.target.value);
    };
    // Filtered options based on search query
    const filteredOptions = options.filter((option) => {
        const matchParent = option.label.toLowerCase().includes(searchQuery.toLowerCase());
        const matchChilds = option.childs?.some((child: any) =>
            child.label.toLowerCase().includes(searchQuery.toLowerCase())
        );
        return matchParent || matchChilds;
    });
    const removeSelectedItems = (e: any) => {
        e.preventDefault();
        setSelectedKey(null);
        setSelectedResolveKey(null);
        setSelectedLabel('');
    }
    
    return (
        <StyledVariblesBox className="menu-comp-parent-div" >
            {/* Div that shows the selected label or default "Open Menu" */}
            {/* {console.log(selectedLabel, "selectedLabel")} */}
            <div className='menu-head-div' onClick={(e: any) => handleClick(e)}>
                <Tooltip
                    arrow
                    enterDelay={1}
                    leaveDelay={0}
                    TransitionComponent={Grow}
                    placement="top"
                    title={selectedLabel || null}
                    >
                    <div className={`${selectedLabel ? 'selected' : ""}`}>
                        {selectedLabel ? selectedLabel : 'Open Menu'}
                    </div>
                </Tooltip>
                {selectedLabel &&
                    <Tooltip
                        arrow
                        enterDelay={1}
                        leaveDelay={0}
                        TransitionComponent={Grow}
                        placement="top"
                        title={"clear"}
                        >
                        <div className="clear-icon" onClick={(e: any) => {removeSelectedItems(e)}}><ClearIcon/></div>
                    </Tooltip>
                }
            </div>
            <Menu
                id="main-menu"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                onMouseLeave={handleNestedMenuClose}
                PaperProps={{
                    style: {
                        maxHeight: '15rem',
                        width: '240px',
                        marginLeft: '-15px',
                        marginTop: '0px',
                    },
                }}
            >
                {/* Search Input Field */}
                <TextField
                    placeholder="Search..."
                    value={searchQuery}
                    onChange={handleSearchChange}
                    sx={{ p: "0.5rem" }}
                />
                {filteredOptions.map((option) => (
                    <div key={option.id}>
                        <MenuItem
                            onClick={option.childs ? (e) => handleNestedMenuOpen(e, option.id) : () => handleMenuItemClick(option)}
                            disabled={props.disabledOptionsList?.includes(option.name)}
                        >
                            <p style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
                                <span>{option.label}</span>
                                <span>{option.childs && ' >'}</span>
                            </p>
                        </MenuItem>
                        {option.childs && (
                            <Menu
                                anchorEl={nestedAnchorEl}
                                open={Boolean(nestedAnchorEl) && hoveredOptionId === option.id}
                                onClose={handleNestedMenuClose}
                                anchorOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'left',
                                }}
                                PaperProps={{
                                    style: {
                                        maxHeight: '15rem',
                                    },
                                }}
                            >
                                {option.childs.map((subOption: any) => (
                                    <MenuItem
                                        key={subOption.id}
                                        onClick={() => handleMenuItemClick(subOption, option)}
                                    >
                                        {subOption.label}
                                    </MenuItem>
                                ))}
                            </Menu>
                        )}
                    </div>
                ))}
            </Menu>
        </StyledVariblesBox>
    );
};
export default MyMenuComponent;
const StyledVariblesBox = styled.div`
    && {
        min-width: 45%;
        min-height: 2rem;
        position: relative;
        gap: 8px;
        display: flex;
        justify-content: center;
        flex-direction: column;
        border: 2px solid transparent;
        background-color: #f7f7f7;
        padding: 0 0.5rem;
        color: #7a7474;
        padding: 0px 0.5rem 0px 14px;
        font-family: Rubik, sans-serif;
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
    }
    .selected {
        color: #030303;
        font-weight: 400;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .menu-head-div {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .clear-icon {
        display: flex;
        justify-content: center;
        align-items: center;
    }
`;